/**
 * custodialListing — helper partagé (DRY §9) pour le listing gasless custodial.
 * CHEMIN 1, SPEC-2026-06-18-gasless-sponsoring.v3.
 *
 * Un user custodial (wallet GENERATED, créé au signup email) n'a pas de MetaMask :
 * il est bloqué dès `enableWeb3()` dans les pages de détail. Or mettre/retirer de la vente
 * est 100% DB côté backend (le txHash on-chain est jeté) et le gate on-chain est bypassé
 * pour ces users sur add/cancel-listing. Ce helper permet aux 4 pages de détail
 * (TileDetails / ItemDetails / TileGroupDetails / ParcelDetails) de choisir la branche
 * SANS dupliquer la logique 4×.
 *
 * Aucune clé de l'user n'est touchée, aucune signature, aucune op on-chain côté custodial.
 */
import { fetchWalletCapabilities } from '../../services/AuthService';

let _cache = null; // null = inconnu ; true/false = capacité résolue pour la session courante

/**
 * isCustodialListingEnabled — true si l'user connecté doit utiliser le listing custodial
 * (DB direct, sans MetaMask). Résultat mémoïsé pour la session (le type de wallet primaire
 * ne change pas en cours de session). Fallback sûr : en cas d'erreur → false (chemin MetaMask).
 *
 * @returns {Promise<boolean>}
 */
export const isCustodialListingEnabled = async () => {
  if (_cache !== null) return _cache;
  try {
    const res = await fetchWalletCapabilities();
    const data = res?.data ?? res;
    _cache = !!(data && data.custodialListing);
  } catch (e) {
    _cache = false; // jamais de bypass par défaut
  }
  return _cache;
};

/** resetCustodialListingCache — à appeler au switch de wallet / logout (la capacité peut changer). */
export const resetCustodialListingCache = () => { _cache = null; };

export default isCustodialListingEnabled;
